import { Box, Grid, Typography, List, ListItem } from "@mui/material";

const Preview2 = ({fieldValues,selectedColor, fullHeight, page='preview', sections}) => {
    let headerFontSize ='30px',subHeaderFontSize ='16px', headerPadding = 5, contentpadding = 3, leftPadding = 8, subContentPadding = 1, titleFontSize = '20px', subTitleFontSize='18px', contentFontSize = '16px';
    if(page === 'template'){
        headerFontSize = '16px'
        subHeaderFontSize = '10px'
        headerPadding = 2
        contentpadding = 1
        leftPadding = 5
        subContentPadding = 0.5
        titleFontSize = '12px'
        subTitleFontSize = '10px'
        contentFontSize = '10px'
    }

    const getexperienceContent = () =>{
        return <Grid item xs={12} px={leftPadding} pt={contentpadding} sx={{color:'#383838'}}>
        <Box sx={{display: 'flex', alignItems: 'center'}}>
            <Typography sx={{fontSize: titleFontSize, color: '#000', fontWeight: 600, paddingRight: '30px'}}> Work History </Typography>
            <Typography sx={{background: selectedColor?.[1] || '#E9932F', flex: 1, height: '3px'}}> </Typography>
        </Box>
        {fieldValues.experience.map((exp, index) => {
                return <Box pt={2} key={index}>
                            <Typography sx={{fontSize: subTitleFontSize, fontWeight: 600}}>{exp.job_title}</Typography>
                            <Box sx={{display: 'flex', justifyContent: 'space-between', fontStyle: 'italic'}}>
                                <Typography sx={{fontSize: contentFontSize}}>{exp.employer}</Typography>
                                <Typography sx={{fontSize: contentFontSize}}>{exp.start_date[1]}/{exp.start_date[0]} - {exp.end_date[1]}/{exp.end_date[0]}</Typography>
                            </Box>
                            {exp.description ? <Typography fontSize={contentFontSize} dangerouslySetInnerHTML={{__html: exp.description?._cache?.html ? exp.description?._cache?.html.toString('html') : exp.description.toString('html')}}></Typography> : ''}
                        </Box>
        })}
    </Grid>
    }
    const geteducationContent = () =>{
        return <Grid item xs={12} px={leftPadding} pt={contentpadding} pb={contentpadding} sx={{color:'#383838'}}>
        <Box sx={{display: 'flex', alignItems: 'center'}}>
            <Typography sx={{fontSize: titleFontSize, color: '#000', fontWeight: 600, paddingRight: '30px'}}> Education </Typography>
            <Typography sx={{background: selectedColor?.[1] || '#E9932F', flex: 1, height: '3px'}}> </Typography>
        </Box>
        {fieldValues.education.map((edu, index) => {
            return <Box pt={1} key={index}>
                <Typography sx={{fontSize:subTitleFontSize}}>{edu.degree} in {edu.field_of_study} of  {edu.start_date[0]} - {edu.end_date[0]}</Typography>
                <Typography sx={{fontSize: contentFontSize}}>{edu.school_name}, {edu.school_location}</Typography>
            </Box>
        })}
    </Grid>
    }
    const getskillsContent = () =>{
        return <Grid item xs={12} px={leftPadding} pt={contentpadding} sx={{color:'#383838'}}>
        <Box sx={{display: 'flex', alignItems: 'center'}}>
            <Typography sx={{fontSize: titleFontSize, color: '#000', fontWeight: 600, paddingRight: '30px'}}> Skills </Typography>
            <Typography sx={{background: selectedColor?.[1] || '#E9932F', flex: 1, height: '3px'}}> </Typography>
        </Box>
        <List disablePadding sx={{ listStyleType: 'disc', paddingLeft: '16px' }}>
            {fieldValues.skills.map((skill, index) => {
                return <ListItem key={index} disablePadding sx={{ display: 'list-item', py: 0.5, fontSize: contentFontSize }}>{skill.skill}</ListItem>
            })}
        </List>
    </Grid>
    }
    const getotherContent = () =>{
        return fieldValues.other.map((other, index)=>{
            return <Grid key={index}  item xs={12} px={leftPadding} pt={contentpadding} pb={contentpadding} sx={{color:'#383838'}}>
                {other.title ? <Box sx={{display: 'flex', alignItems: 'center'}}>
                <Typography sx={{fontSize: titleFontSize, color: '#000', fontWeight: 600, paddingRight: '30px'}}>{other.title}</Typography>
                <Typography sx={{background: selectedColor?.[1] || '#E9932F', flex: 1, height: '3px'}}> </Typography>
            </Box> : ''}
                {other.content ? <Box pt={1}><Typography sx={{fontSize:contentFontSize}} dangerouslySetInnerHTML={{__html: other.content?._cache?.html ? other.content?._cache?.html.toString('html') : other.content.toString('html')}}></Typography></Box> : ''}
            </Grid>
        })
    }

    return <Box sx={{ boxShadow: "rgba(0, 0, 0, 0.35) 0px 5px 15px", width:"100%", flexGrow:1,  height: fullHeight ? "100%" : 'auto'  }}>
            <Box pl={headerPadding} >
                <Grid container sx={{backgroundColor:selectedColor?.[0] || '#588981', alignItems: 'center', borderTopLeftRadius: '50px', borderBottomLeftRadius: '50px', color: '#fff', flexGrow:1}} px={headerPadding} py={contentpadding}>
                    <Grid item xs={6}>
                        <Typography sx={{fontSize: headerFontSize, fontWeight: 600, color: selectedColor?.[2] || '#000'}}>
                            {fieldValues.f_name || 'John'} {fieldValues.l_name}
                        </Typography>
                    </Grid>
                    <Grid item xs={6} sx={{textAlign: 'right'}}>
                        <Typography sx={{fontSize: subHeaderFontSize, color: selectedColor?.[2] || '#000'}}>
                            {fieldValues.city || "City"}, {fieldValues.state || "State"}
                        </Typography>
                        <Typography sx={{fontSize: subHeaderFontSize, color: selectedColor?.[2] || '#000'}}>
                            {fieldValues.phone || "Phone Number"} | {fieldValues.email|| "xxx@gmail.com"}
                        </Typography>
                    </Grid>
                </Grid>
            </Box>

            {fieldValues.objective ? <Grid item xs={12} px={leftPadding} pt={contentpadding} sx={{color:'#383838'}}>
                <Typography sx={{fontSize: contentFontSize}}>{fieldValues.objective}</Typography>
            </Grid> : ""}

            {sections?.map((section)=>{
                    if(section === 'Education'){
                        return fieldValues.education.length ? geteducationContent() : ''
                    }else if(section === 'Experience'){
                        return fieldValues.experience.length ? getexperienceContent() : ''
                    }else if(section === 'Skills'){
                        return fieldValues.skills.length ? getskillsContent() : ''
                    }else if(section === 'Other'){
                        return fieldValues.other.length && fieldValues.other[0].title ? getotherContent() : ''
                    }
                    return ''
                })
            }
        </Box>

}


export default Preview2;